import { Grid } from '@mui/material';
import { memo, useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import ViewerPDF from 'shell/components/shared/pdf-modal/pdf-viewer';
import { PmiButton } from 'shell/components/shared/button';
import { HttpResponse } from 'shell/models/http-response';
import { ResponsePreview } from 'civil-status/view-models/step-form';

interface DocumentVisualizationANSCProps {
  onBack: () => void;
}

const DocumentVisualizationANSCComponent = ({
  onBack,
}: DocumentVisualizationANSCProps): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  // Get Atto ANSC
  const [act] = useHttpFetch<HttpResponse<ResponsePreview>, string | undefined>(
    `${__ACT_API_URL__}/evento/anteprima/idAnsc/${formContext.values.chosenDocument?.actNumber}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) => {
        return response.data.payload.eventoOutput?.contenuto;
      },
    }
  );

  const actData = act.data as unknown as string;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const reference = useRef<HTMLDivElement | null>(null);

  return (
    <div className="pmi-ml-3" ref={reference}>
      <Grid item container spacing={0} rowSpacing={2} columnSpacing={10} xs={12}>
        <Grid item xs={12}>
          <ViewerPDF
            fixedDimension={reference.current?.clientWidth}
            data={actData}
            name="Documento ANSC"
          />
        </Grid>
        <Grid item xs={12}>
          <div className="pmi-pt-3 pmi-d-flex pmi-justify-content-center">
            <div className="pmi-w-25 pmi-w-lg-15">
              <PmiButton variant="outlined" fullWidth color="secondary" onClick={onBack}>
                Indietro
              </PmiButton>
            </div>
            <div className="pmi-pl-2 pmi-w-25 pmi-w-lg-15">
              <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="submit">
                Avanti
              </PmiButton>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

DocumentVisualizationANSCComponent.displayName = 'Document ANSC form component';

const DocumentVisualizationANSCForm = memo(DocumentVisualizationANSCComponent);

export default DocumentVisualizationANSCForm;
